import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Grid, Alert } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Layout from "./Layout";
import { login } from "../actions/authenActions";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    //user_id: "Woodland",
    //password: "Pass1@345678",
    user_id: "",
    password: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [submissionError, setSubmissionError] = useState(null);

  const loggedInUser = useSelector((state) => state.authen.loggedInUser);

  useEffect(() => {
    if (loggedInUser) {
      if (loggedInUser.status === "Pass") {
        navigate("/dashboard");
      } else {
        setSubmissionError(loggedInUser.message || "Login failed");
      }
    }
  }, [loggedInUser, navigate]);

  function validate() {
    const errors = {};

    if (!formData.user_id) {
      errors.user_id = "Username is required";
    }

    if (!formData.password) {
      errors.password = "Password is required";
    }

    return errors;
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    setSubmissionError(null);
  }

  function handleSubmit(e) {
    e.preventDefault();

    const errors = validate();
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    dispatch(login(formData))
      .then(() => {
        // handled by useEffect
      })
      .catch((error) => {
        setSubmissionError(error?.message || "An unexpected error occurred");
      });
  }

  return (
    <>
      <Layout>
        <Typography variant="h5" gutterBottom>
          Login
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          autoComplete="off"
          sx={{ mt: 2 }}
        >
          {submissionError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {submissionError}
            </Alert>
          )}

          <TextField
            label="Username"
            name="user_id"
            fullWidth
            margin="normal"
            value={formData.user_id}
            onChange={handleChange}
            error={!!formErrors.user_id}
            helperText={formErrors.user_id}
          />

          <TextField
            label="Password"
            type="password"
            name="password"
            fullWidth
            margin="normal"
            value={formData.password}
            onChange={handleChange}
            error={!!formErrors.password}
            helperText={formErrors.password}
          />

          <Button fullWidth variant="contained" type="submit" sx={{ mt: 2 }}>
            Login
          </Button>

          <Grid container spacing={1} mt={2}>
            <Grid item xs={12}>
              <Link to="/register">New here? Sign Up</Link>
            </Grid>
            <Grid item xs={12}>
              <Link to="/forgot">Forgot Credentials</Link>
            </Grid>
            <Grid item xs={12}>
              <Link to="/change-password">Change Password?</Link>
            </Grid>
          </Grid>
        </Box>
      </Layout>
    </>
  );
};

export default Login;
